import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin, message } from "antd";
import ReactApexChart from "react-apexcharts";
import { fetchAlertBarGraphData } from "../../redux/slices/graphSlice";

const TravelDetailsView = (props) => {
  const { startDate, endDate, startTime, endTime, dashboardClicked } =
    useSelector((state) => state.filters);
  const dispatch = useDispatch();
  // const { dates, callFromDashboard } = props;
  const [value, setValue] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const getBarGraphList = async (dates) => {
    try {
      let params = dates;
      setLoading(true); // Set loading to true before the API call
      const resultAction = await dispatch(
        fetchAlertBarGraphData({ ...params })
      );
      if (fetchAlertBarGraphData.fulfilled.match(resultAction)) {
        let {
          status,
          data: { cameraAlertCount },
        } = resultAction.payload;
        if (status === 200) {
          setLoading(false);
          let cameraNames = cameraAlertCount.map((item) => item.camera);
          let countsValues = cameraAlertCount.map(
            (item) => item.counts[0] || 0
          );
          setCategories(cameraNames);
          setValue(countsValues);
        }
      } else {
        message.error(resultAction.payload || "Something went wrong");
      }
    } catch (error) {
      console.error("Error fetching pie chart data:", error);
    } finally {
      setLoading(false); // Set loading to false after the API call completes
    }
  };

  const fetchData = () => {
    let dates = { startDate, startTime, endDate, endTime };
    getBarGraphList(dates);
  };

  useEffect(() => {
    if (dashboardClicked >= 0) {
      setLoading(true);
      fetchData();
    }
  }, [dashboardClicked]);

  const chartData = {
    chart: {
      id: "apexchart-example",
      type: "bar",
      foreColor: ["#F44336", "#E91E63", "#9C27B0"],
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top",
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#333"],
          },
          offsetX: 30,
        },
      },
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: false,
          customIcons: [],
        },
      },
    },
    xaxis: {
      type: "category",
      categories: categories,
      tickAmount: undefined,
      tickPlacement: "between",
      labels: {
        show: true,
        rotate: -45,
        style: {
          colors: "#000000",
          fontSize: "12px",
          fontFamily: "Helvetica, Arial, sans-serif",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return Math.floor(value); // Ensure Y-axis values are integers
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const cameraName = categories[dataPointIndex];
        const alertCount = series[seriesIndex][dataPointIndex];
        return `<div style="padding: 10px; font-size: 12px; color: #333;">
                <strong>Camera:</strong> ${cameraName}<br>
                <strong>Count:</strong> ${alertCount}<br>
              </div>`;
      },
    },
    series: [
      {
        name: "Total Count",
        type: "column",
        data: value,
      },
    ],
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        const colors = [
          "#3B3561",
          "#4481B3",
          "#187D8A",
          "#97C6FF",
          "#5D0202",
          "#7C769E",
          "#FC7A57",
          "#9D4F4F",
          "#EE9F9F",
          "#F5A27E",
          "#AC7070",
          "#5E9180",
          "#1E603A",
          "#6C915E",
        ];
        return colors[dataPointIndex % colors.length] || "skyblue";
      },
    ],
  };

  // const allValuesAreZero = value.every((val) => val === 0);

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
          <span className="mx-3" style={{ color: "slategray" }}>
            Loading please wait...
          </span>
        </div>
      ) : value.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <div>No Data Available</div>
        </div>
      ) : (
        <div className="mt-3">
          <ReactApexChart
            options={chartData}
            series={chartData.series}
            width="100%"
            height={300}
            type="bar"
          />
        </div>
      )}
    </>
  );
};

const ApexBarGraph = (props) => {
  const { callFromDashboard, dates } = props;
  return (
    <TravelDetailsView callFromDashboard={callFromDashboard} dates={dates} />
  );
};

export default ApexBarGraph;
